import React, {useState, useEffect, useRef}  from 'react';
import { useDispatch, useSelector } from "react-redux";
import Layout from "../../layout/Layout";
import moment from 'moment';

import { useropen } from '../../redux/userInfo';
import { open, close, loadingflas } from '../../redux/popupSlice';
import { Link, useNavigate } from 'react-router-dom';
import { Calendar, momentLocalizer } from 'react-big-calendar'
import 'react-big-calendar/lib/css/react-big-calendar.css';
import "../../css/calendar.css";

import Input from '../../component/Input';
import Button from '../../component/Button';
import Select from '../../component/Select';
import ScheduleInputs from '../../component/ScheduleInputs';
import { useGoogleLogin } from '@react-oauth/google';
import { getMemberinfo, hpHypen, numFormat, useIntersectionObserver } from "../../utils/utils";

import * as APIS from "../../utils/service";
import { googleLogout } from '@react-oauth/google';


export default function Schedules({ navigation }) {
    const localizer = momentLocalizer(moment);
    moment.locale('ko-KR');

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const SCREENWIDTH = window.innerWidth;
    const height = window.innerHeight;
    const calendarRef = useRef();
    const [memberinfos, setmemberinfos] = useState(''); 
    
    const [inputArr, setinputArr] = useState([]);   
    const [mb_id, setmb_id] = useState('');   
    const [mb_pass, setmb_pass] = useState('');   

    const [thisyear, setthisyear] = useState(moment().format('YYYY'));
    const [thismonth, setthismonth] = useState(moment().format('MM'));
    const [thisday, setthisday] = useState(moment().format('DD'));
    const [thisyoil, setthisyoil] = useState(moment().day());
    const [thistoday, setthistoday] = useState(moment().format('DD'));
    const [thistodayMonth, setthistodayMonth] = useState(moment().format('MM'));
    const [thistodayYear, setthistodayYear] = useState(moment().format('YYYY'));
    const [datelist, setdatelist] = useState([]);
    const [selTime, setselTime] = useState('');
    const [popflag, setpopflag] = useState(false);
    const [buttonFlag, setbuttonFlag] = useState(false);
    const [popcomments, setpopcomments] = useState(''); 
    
    const [scheculestate, setscheculestate] = useState('임장');
    const [colorlists, setcolorlists] = useState('');
    const [scheculecolor, setscheculecolor] = useState('3');
    

    const [sely1, setsely1] = useState(moment().format('YYYY'));
    const [selm1, setselm1] = useState(moment().format('MM'));
    const [seld1, setseld1] = useState(moment().format('DD'));
    const [selsh1, setselsh1] = useState(moment().format('HH'));
    const [selsmin1, setselsmin1] = useState('00');
    const [seleh1, setseleh1] = useState(moment().format('HH'));
    const [selemin1, setselemin1] = useState('00');
    
    const [sely2, setsely2] = useState(moment().format('YYYY'));
    const [selm2, setselm2] = useState(moment().format('MM'));
    const [seld2, setseld2] = useState(moment().format('DD'));
    const [selsh2, setselsh2] = useState(moment().format('HH'));
    const [selsmin2, setselsmin2] = useState('00');
    const [seleh2, setseleh2] = useState(moment().format('HH'));
    const [selemin2, setselemin2] = useState('00');
    const [eventids, seteventids] = useState('');
    const [Todaybutton, setTodaybutton] = useState(false);
    
    const yoil = ['일', '월', '화', '수', '목', '금', '토'];
    useEffect(() => {
        getMemberinfo(setmemberinfos);
    }, []);
    //console.log(memberinfos);

    const [scheduleArr, setscheduleArr] = useState([
        {
            dates: '5.15', yoil: '수',
            lists: [
                {dates: '5.15', shour: '16', smin: '00', ehour: '16', emin: '50', seltype: '임장', comments: '결정력이 떨어짐. 다음 미팅을 기준으로 자동고객관리 대상 판단'},
                {dates: '5.15', shour: '19', smin: '00', ehour: '00', emin: '00', seltype: '잔금일', comments: '골든타원 102호 잔금일, 7시에 골든부동산에서 만나기로함.'},
            ]
        },
        {
            dates: '5.17', yoil: '금',
            lists: [
                {dates: '5.17', shour: '16', smin: '00', ehour: '16', emin: '50', seltype: '임장', comments: '삼결살집 임장'},
            ]
        },
        {
            dates: '5.18', yoil: '토',
            lists: [
                {dates: '5.18', shour: '16', smin: '00', ehour: '16', emin: '50', seltype: '임장', comments: '삼결살집 임장'},
            ]
        },
        {
            dates: '5.22', yoil: '수',
            lists: [
                {dates: '5.22', shour: '16', smin: '00', ehour: '16', emin: '50', seltype: '휴가', comments: '5.22(월)~5.31(수)' },
            ]
        },
        {
            dates: '5.23', yoil: '목',
            lists: [
                {dates: '5.23', shour: '16', smin: '00', ehour: '16', emin: '50', seltype: '휴가', comments: '5.22(월)~5.31(수)' },
                {dates: '5.23', shour: '19', smin: '00', ehour: '00', emin: '00', seltype: '임장', comments: '삼결살집 임장'},
            ]
        },
    ]);   

    const [eventlist, seteventlist] = useState([]);
    const [eventgrouplist, seteventgrouplist] = useState('');

    useEffect(() => {
        console.log("!!!", eventgrouplist);
    }, [eventgrouplist]);
    useEffect(() => {
        colorlistSet();
    }, []);
        
    useEffect(() => {
        setthisyoil(moment(`${thisyear}-${thismonth}-${thisday}`).day());
        console.log(thisyear, thismonth);
        if(colorlists !== ''){
            getschedultlist();
        }
    }, [colorlists, thismonth]);

    const Toolbar = (props) => {
        //console.log(props);
        const { date, } = props;
    
        const calendarnavigate = (action) => {
            props.onNavigate(action);
        };        
        return (
            <div
                style={{
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    flexDirection: 'row', gap: 40, marginTop: 20, marginBottom: 20
                }}
            >
                <button
                    style={{ 
                        display: 'flex', alignItems: 'center', justifyContent: 'center', width: 24, height: 24, backgroundColor: '#EEE',
                        borderRadius: 100
                    }}
                    onClick={() => {
                        dispatch(loadingflas({ loading: true }));
                        setthisyear(moment(thisyear+''+thismonth+''+thisday).add(-1, 'M').format('YYYY'));
                        setthismonth(moment(thisyear+''+thismonth+''+thisday).add(-1, 'M').format('MM'));
                        calendarnavigate('PREV')
                    }}                              
                >
                    <svg xmlns="http://www.w3.org/2000/svg" width="9" height="13" viewBox="0 0 9 13" fill="none">
                        <path d="M3.3284 6.36398L8.2782 11.3137L6.864 12.7279L0.5 6.36398L6.864 0L8.2782 1.41421L3.3284 6.36398Z" fill="#999999"/>
                    </svg>
                </button>
                <span className='fontsize24 bolds'>{moment(date).format('YYYY.MM')}</span>  
                <button
                    style={{ 
                        display: 'flex', alignItems: 'center', justifyContent: 'center', width: 24, height: 24, backgroundColor: '#EEE',
                        borderRadius: 100
                    }}
                    onClick={() => {
                        dispatch(loadingflas({ loading: true }));
                        setthisyear(moment(thisyear+''+thismonth+''+thisday).add(1, 'M').format('YYYY'));
                        setthismonth(moment(thisyear+''+thismonth+''+thisday).add(1, 'M').format('MM'));
                        calendarnavigate('NEXT')
                    }}                            
                >
                    <svg xmlns="http://www.w3.org/2000/svg" width="9" height="13" viewBox="0 0 9 13" fill="none">
                        <path d="M5.6716 6.36398L0.7218 11.3137L2.136 12.7279L8.5 6.36398L2.136 0L0.7218 1.41421L5.6716 6.36398Z" fill="#999999"/>
                    </svg>
                </button>
            </div>
        );
    }
    const CustomDateHeader = (props) => {
        const { date, isOffRange, label } = props;
        let ckSunday = moment(date).day();
        let ckMonth = moment(date).format('MM');

        let backgrounds = "#fff";
        let colors = '#333';
        let fweight = 400;
        if(ckSunday === 0){
            colors = '#FF0000';
        }
        if(ckSunday === 6){
            colors = '#0075FF';
        }

        if(thistoday*1 === label*1 && ckMonth === thistodayMonth){
            backgrounds = "#6164A5";
            colors = '#fff';
            fweight = 700;
        }
        return (
        <button 
            style={{ 
                width: 'calc(14.285714285714286% - 0.9px)', width: 24, height: 24, margin: 8, marginBottom: 5,
                display: 'flex', alignItems: 'flex-start', justifyContent: 'flex-start',
            }}
            onClick={() => {
                if(memberinfos?.compony){
                    setpopflag(true);
                    setseld1(label);
                    setseld2(label);
                    setselm1(ckMonth);
                    setselm2(ckMonth);
                } else {
                    componyAlert();
                }
            }}
        >
            <div 
                style={{
                    display: 'flex', alignItems: 'center', justifyContent: 'center', position: 'relative',
                    backgroundColor: backgrounds, borderRadius: '50%', width: 24, height: 24, opacity: 1 
                }}
            >
                <span style={{
                    color: isOffRange ? '#ccc' : colors, 
                    fontWeight: fweight, 
                }}>{label}</span>                         
            </div>
        </button>
        );
    }
    const colorlistSet = () => {
        let sender = {}
        dispatch(loadingflas({ loading: true }));
        APIS.postData('/v1/schedule/colors', sender).then(({ data }) => {
            if(data){
                console.log("????????????", JSON.stringify(data));
                setcolorlists(data);
            }
        }).catch(({ response }) => {
            const { data } = response;
        }).finally(() => {
            dispatch(loadingflas({ loading: false }));
        });  
    }
    const googlelogin = useGoogleLogin({
        onSuccess: tokenResponse => {
            //console.log(tokenResponse)
            const { code } = tokenResponse;

            dispatch(loadingflas({ loading: true }));
            let sender = {
                type: 'google',
                code: code,
            }

            console.log(sender);
            APIS.postData('/v1/oauth/getToken', sender).then(({ data }) => {
                console.log(data);
                if(data){
                    // dispatch(
                    //     useropen({
                    //         userdata: {login: true}
                    //     })
                    // ); 
                    getMemberinfo(setmemberinfos);
                    colorlistSet();
                }
            }).catch(({ response }) => {
                const { data } = response;
                console.log(data);
            }).finally(() => {
                dispatch(loadingflas({ loading: false }));
            });   
            
        },
        flow: 'auth-code',
        // scope: 'https://www.googleapis.com/auth/calendar https://www.googleapis.com/auth/tasks'
        scope: 'https://www.googleapis.com/auth/calendar'
    });

    const getschedultlist = () => {
        
        let sender = {
            year: thisyear,
            month: thismonth
        }
        APIS.postData('/v1/schedule/events', sender).then(({ data }) => {
            if(data){
                console.log(data);
                //setlists(data);
                let listpush = [];
                
                // {
                //     start: moment().format('YYYY-MM-DD HH:mm:ss'),
                //     end: moment().format('YYYY-MM-DD HH:mm:ss'),
                //     title: <div ><span className='colorF00 fontsize10'>111</span>22222</div>,
                //     id: '3'
                // }
                
                data?.map((x, i) => {
                    let descriptions = x?.description?.replace(/<[^>]*>?/g, '');
                    if(!x?.end?.dateTime) {
                        return;
                    }
                    listpush.push({
                        start: moment(x?.start?.dateTime).format('YYYY-MM-DD HH:mm:ss'),
                        end: moment(x?.end?.dateTime).format('YYYY-MM-DD HH:mm:ss'),
                        startdates: moment(x?.start?.dateTime).format('YYYY-MM-DD'),
                        enddates: moment(x?.end?.dateTime).format('YYYY-MM-DD'),
                        startmonth: moment(x?.start?.dateTime).format('YYYYMM')*1,
                        endmonth: moment(x?.end?.dateTime).format('YYYYMM')*1,
                        title: descriptions,
                        scheculestate: x?.summary,
                        id: x?.id,
                        backgrounds: colorlists[x?.colorId]?.background || colorlists[1]?.background,
                        foregrounds: colorlists[x?.colorId]?.foreground || colorlists[1]?.foreground,
                        orderbydates: moment(x?.start?.dateTime).format('YYYYMMDDHHmmss')*1,
                        colorId: x?.colorId || 1,
                    });
                })

                //thistodayMonth
                //thistodayYear
                listpush = listpush.sort(function (a, b) {
                    if(a.hasOwnProperty('orderbydates')){
                        return a.orderbydates - b.orderbydates;
                    }
                });
                //console.log(listpush);
                let ckgroupdate = thisyear+thismonth;
                let groupfilters = listpush?.filter( item => (item?.startmonth*1 === ckgroupdate*1 || item?.endmonth*1 === ckgroupdate*1))

                let groupresult = groupfilters.reduce((acc, curr) => {  // [1]
                    const { startdates } = curr;                        // [2]
                    if (acc[startdates]) acc[startdates].push(curr);  // [3]
                    else acc[startdates] = [curr];              // [4]
                    return acc;                           // [5]
                }, {});                                 // [6]
                
                console.log("dhdld???", groupresult);

                seteventlist(listpush);
                seteventgrouplist(groupresult);
            }
        }).catch(({ response }) => {
            const { data } = response;
            console.log("리스트??!!", data);

        }).finally(() => {
            dispatch(loadingflas({ loading: false }));
        });     
    }
    const schedulteventclear = () => {
        setpopflag(false);
        setbuttonFlag(false);
        setscheculestate('임장')
        seteventids('');
        setpopcomments('');
        setscheculecolor('3');
    }
    const showeventPop = (event) => {
        console.log(event, moment(event?.start?.dateTime).format('DD'), moment(event?.end).format('DD'));
        if(!memberinfos?.compony){
            dispatch(
                open({
                    component: `사무소 등록·소속 후 이용 가능합니다.`,
                    title: '알림',
                    titleviewer: true,
                    alert: false,
                    button: "확인",
                    onPress: () => {
                        dispatch(close());
                    }
                })
            );  
            return;
        }
        if(event?.startdates !== event?.enddates){
            setsely1(moment(event?.start).format('YYYY'));
            setselm1(moment(event?.start).format('MM'));
            setseld1(moment(event?.start).format('DD'));
            setselsh1(moment(event?.start).format('HH'));
            setselsmin1(moment(event?.start).format('mm'));
            setsely2(moment(event?.end).format('YYYY'));
            setselm2(moment(event?.end).format('MM'));
            setseld2(moment(event?.end).format('DD'));
            setselsh2(moment(event?.end).format('HH'));
            setselsmin2(moment(event?.end).format('mm'));
            setbuttonFlag(true);
            // setsely={setsely2} setselm={setselm2} setseld={setseld2}
            // setselsh={setselsh2} setselsmin={setselsmin2} 
            // setseleh={setseleh2} setselemin={setselemin2}     


        } else {
            setbuttonFlag(false);
            setsely1(moment(event?.start).format('YYYY'));
            setselm1(moment(event?.start).format('MM'));
            setseld1(moment(event?.start).format('DD'));
            setselsh1(moment(event?.start).format('HH'));
            setselsmin1(moment(event?.start).format('mm'));
            setseleh1(moment(event?.end).format('HH'));
            setselemin1(moment(event?.end).format('mm'));            
        }
        seteventids(event?.id);
        setscheculestate(event?.scheculestate);
        setpopcomments(event?.title);
        setscheculecolor(event?.colorId);
        setpopflag(true);
    }

    const calenderLogout = () => {
        let sender = {}
        APIS.postData('/v1/schedule/logout', sender).then(({ data }) => {
            if(data){
                window.location.reload();
            }
        }).catch(({ response }) => {
            const { data } = response;
            console.log(data);
        }).finally(() => {
            dispatch(loadingflas({ loading: false }));
        });            
    }

    useEffect(() => {
        if(buttonFlag === true){
            let dates = `${sely1}-${selm1}-${seld1} ${selsh1}:${selsmin1}:00`;

            setsely2(sely2 ? sely2 : sely1);
            setselm2(selm2 ? selm2 : selm1);
            setseld2(seld2 ? seld2 : seld1);
            if(selsh1*1 === 23){
                setselsh2('23');
            } else {
                setselsh2(moment(dates).add(+1, 'H').format('HH'));
            }
        }

    }, [buttonFlag, selsh1, sely1, selm1, seld1]);
    const componyAlert = () => {
        dispatch(
            open({
                component: `사무소 등록·소속 후 이용 가능합니다.`,
                title: '알림',
                titleviewer: true,
                alert: false,
                button: "확인",
                onPress: () => {
                    dispatch(close());
                }
            })
        );  
    }
    return(
        <>
        {!memberinfos?.access_token && 
        <div 
        style={{ 
            position: 'fixed', left: 0, top: 0, zIndex: 1000, width: '100%', height: '100%',
            backgroundColor: 'rgba(0,0,0,0.8)', backdropFilter: 'blur(2px)',
            display: 'flex', alignItems: 'center', justifyContent: 'center'

        }}>
            <div style={{ 
                padding: 30, borderRadius: 10, backgroundColor: '#fff', width: 300,
                display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', gap: 20
            }}>
                <div className='bolds'>구글 로그인을 먼저 해주세요!</div>
                <Button
                    buttonTxt={'구글 로그인 하기'}
                    className={'linenormalbutton'}
                    onPress={() => {
                        googlelogin();
                    }}             
                    styles={{ backgroundColor: '#fff' }}                
                />
                <Button
                    onPress={() => {
                        navigate(-1);
                    }}                    
                    buttonTxt={'페이지 나가기'}
                />
            </div>
        </div>
        }
        <Layout header={false} actives={'3'}>
            <div className='schedulearea'>
                <div className='padding32'>
                    <Calendar
                        ref={calendarRef}
                        localizer={localizer}
                        events={eventlist}
                        startAccessor="start"
                        endAccessor="end"
                        popup={true}
                        messages={{
                            showMore:(count) => {
                                return (
                                    <div style={{ fontSize: 10 }}>+{count} more</div>
                                );
                            }
                        }}

                        components={{
                            toolbar: Toolbar,
                            eventWrapper: (props) => {
                                const { event } = props;
                                //console.log(event);
                                return (
                                    <button 
                                        style={{ 
                                            padding: 3, background: event?.backgrounds, color: event?.foregrounds,
                                            borderRadius: 3, fontSize: 10, textAlign: 'left',
                                            display: 'inline-block', width: '100%', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis'
                                        }}
                                        onClick={() => {
                                            showeventPop(event);
                                        }}
                                    >
                                        {moment(event?.start).format('HH:mm')} [{event?.scheculestate}]{event?.title}
                                    </button>
                                );

                            },
                            month: {
                                dateHeader: CustomDateHeader,
                            },
                        }}
                    />
                    <div
                        style={{
                            display: 'flex', alignItems: 'center', justifyContent: 'flex-start', gap: 10,
                            marginTop: 20 
                        }}
                    >
                        <div>구글 캘린더로 스케줄을 전송합니다.</div>
                        <div>
                            <Button 
                                buttonTxt={'연동해제'} 
                                className={`selectlistclear`} 
                                styles={{
                                    color: '#fff', fontSize: 12, backgroundColor: '#999999'
                                }}
                                onPress={() => {
                                    calenderLogout();
                                }} 
                            />  
                        </div>
        
                    </div>
                    
                </div>
                <div style={{
                    height: 843, overflow: 'auto', justifyContent: 'flex-start'
                }}>
                    <div >
                        <Button
                            buttonTxt={'오늘'}
                            className={'linenormalbutton'}
                            styles={{
                                width: 64, height: 32, fontSize: 14
                            }}
                            onPress={() => {
                                setTodaybutton(!Todaybutton);
                                if(thisyear+thismonth !== thistodayYear+thistodayMonth){
                                    dispatch(loadingflas({ loading: true }));
                                    calendarRef?.current?.handleNavigate('TODAY');
                                    setthisyear(thistodayYear);
                                    setthismonth(thistodayMonth);
                                }
                            }}                             
                        />
                    </div>
                    {Todaybutton && eventgrouplist && colorlists && Object.keys(eventgrouplist).filter(item => item === `${thistodayYear}-${thistodayMonth}-${thistoday}`)?.map((x, i) => {
                        let listsdata = x?.lists;
                        //console.log(listsdata);
                        return (
                            <div key={'Arr'+i} className='scheduleListarea'>
                                <div style={{ gap: 4 }}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                        <path d="M7.49935 0.833252V2.49992H12.4993V0.833252H14.166V2.49992H17.4993C17.9596 2.49992 18.3327 2.87302 18.3327 3.33325V16.6666C18.3327 17.1268 17.9596 17.4999 17.4993 17.4999H2.49935C2.03912 17.4999 1.66602 17.1268 1.66602 16.6666V3.33325C1.66602 2.87302 2.03912 2.49992 2.49935 2.49992H5.83268V0.833252H7.49935ZM16.666 8.33325H3.33268V15.8333H16.666V8.33325ZM12.5289 9.27992L13.7074 10.4585L9.58268 14.5833L6.63641 11.637L7.81492 10.4585L9.58268 12.2263L12.5289 9.27992ZM5.83268 4.16659H3.33268V6.66658H16.666V4.16659H14.166V4.99992H12.4993V4.16659H7.49935V4.99992H5.83268V4.16659Z" fill="#999999"/>
                                    </svg>                                    
                                    <span className='bolds'>{moment(x).format('MM.DD')}({yoil[moment(x).day()]})</span>
                                </div>
                                <div>
                                {eventgrouplist[x]?.map((x2, i2) => {
                                    if(x2?.startdates === x2?.enddates){
                                        return (
                                            <div key={i2} className='normals'>
                                                <div>
                                                    {x2?.start === x2?.end ?
                                                        <>{moment(x2?.start).format('HH:mm')}</>
                                                    :
                                                        <>{moment(x2?.start).format('HH:mm')} ~ {moment(x2?.end).format('HH:mm')}</>
                                                    } 
                                                </div>
                                                <div>
                                                    <div className='bolds' style={{ color: colorlists[x2?.colorId]?.background}}>{x2?.scheculestate}</div>
                                                    <div>{x2?.title}</div>
                                                </div>
                                            </div>
                                     
                                        );
                                    } else {
                                        return (
                                            <div key={i2} className='vacations'>
                                                <div className='colorF00'>{x2?.title}</div>
                                                <div>
                                                    {moment(x2?.start).format('MM.DD')}({yoil[moment(x).day()]})
                                                    ~
                                                    {moment(x2?.end).format('MM.DD')}({yoil[moment(x).day()]})
                                                </div>
                                            </div>       
                                        );
                                    }
                                })}
                                </div>
                                
                            </div>
                        );
                    })}

                    {eventgrouplist && colorlists && Object.keys(eventgrouplist)?.map((x, i) => {
                        let listsdata = x?.lists;
                        //console.log(x);
                        return (
                            <div key={'Arr'+i} className='scheduleListarea'>
                                <div style={{ gap: 4 }}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                        <path d="M7.49935 0.833252V2.49992H12.4993V0.833252H14.166V2.49992H17.4993C17.9596 2.49992 18.3327 2.87302 18.3327 3.33325V16.6666C18.3327 17.1268 17.9596 17.4999 17.4993 17.4999H2.49935C2.03912 17.4999 1.66602 17.1268 1.66602 16.6666V3.33325C1.66602 2.87302 2.03912 2.49992 2.49935 2.49992H5.83268V0.833252H7.49935ZM16.666 8.33325H3.33268V15.8333H16.666V8.33325ZM12.5289 9.27992L13.7074 10.4585L9.58268 14.5833L6.63641 11.637L7.81492 10.4585L9.58268 12.2263L12.5289 9.27992ZM5.83268 4.16659H3.33268V6.66658H16.666V4.16659H14.166V4.99992H12.4993V4.16659H7.49935V4.99992H5.83268V4.16659Z" fill="#999999"/>
                                    </svg>                                    
                                    <span className='bolds'>{moment(x).format('MM.DD')}({yoil[moment(x).day()]})</span>
                                </div>
                                <div>
                                {eventgrouplist[x]?.map((x2, i2) => {
                                    if(x2?.startdates === x2?.enddates){
                                        return (
                                            <div key={i2} className='normals'>
                                                <div>
                                                    {x2?.start === x2?.end ?
                                                        <>{moment(x2?.start).format('HH:mm')}</>
                                                    :
                                                        <>{moment(x2?.start).format('HH:mm')} ~ {moment(x2?.end).format('HH:mm')}</>
                                                    } 
                                                </div>
                                                <div>
                                                    <div className='bolds' style={{ color: colorlists[x2?.colorId]?.background}}>{x2?.scheculestate}</div>
                                                    <div>{x2?.title}</div>
                                                </div>
                                            </div>
                                     
                                        );
                                    } else {
                                        return (
                                            <div key={i2} className='vacations'>
                                                <div className='colorF00'>{x2?.title}</div>
                                                <div>
                                                    {moment(x2?.start).format('MM.DD')}({yoil[moment(x).day()]})
                                                    ~
                                                    {moment(x2?.end).format('MM.DD')}({yoil[moment(x).day()]})
                                                </div>
                                            </div>       
                                        );
                                    }
                                })}
                                </div>
                                
                            </div>
                        );
                    })}
                    {Object.keys(eventgrouplist).length === 0 &&
                        <div className='nolistArea' style={{ width: '100%'}}>
                            일정이 없습니다.
                        </div>
                    }
                </div>
            </div>
        </Layout>
        {popflag === true &&
        <div className='PopupArea'>
            <div>
                <div className='PopupAreaBG' 
                    //onClick={() => { schedulteventclear(); }}
                />
                <div className='PopupAreaContents' style={{ width: 500 }}>
                    <div>
                        <div className="popTitle padding20">
                            <span >스케줄</span>
                            <button
                                onClick={() => {
                                    schedulteventclear();
                                }}
                            >
                                <img src="./images/icons/x.svg" width='20' />                                            
                            </button>
                        </div>
                        <div className="padding32">
                            <div className='popcontents schduleArea'>
                            <div>
                            <div
                                    style={{
                                        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                                    }}
                                >
                                    <Button buttonTxt={'임장'} className={`writeRadiobutton3 ${scheculestate === '임장' ? 'active' : ''}`} onPress={() => {
                                        setscheculestate('임장');
                                        setscheculecolor('3');
                                    }} />
                                    <Button buttonTxt={'미팅'} className={`writeRadiobutton3 ${scheculestate === '미팅' ? 'active' : ''}`} onPress={() => {
                                        setscheculestate('미팅');
                                        setscheculecolor('7');
                                    }} />
                                    <Button buttonTxt={'가계약'} className={`writeRadiobutton3 ${scheculestate === '가계약' ? 'active' : ''}`} onPress={() => {
                                        setscheculestate('가계약');
                                        setscheculecolor('11');
                                    }} />
                                    <Button buttonTxt={'본계약'} className={`writeRadiobutton3 ${scheculestate === '본계약' ? 'active' : ''}`} onPress={() => {
                                        setscheculestate('본계약');
                                        setscheculecolor('11');
                                    }} />
                                    <Button buttonTxt={'중도금'} className={`writeRadiobutton3 ${scheculestate === '중도금' ? 'active' : ''}`} onPress={() => {
                                        setscheculestate('중도금');
                                        setscheculecolor('9');
                                    }} />
                                    <Button buttonTxt={'잔금일'} className={`writeRadiobutton3 ${scheculestate === '잔금일' ? 'active' : ''}`} onPress={() => {
                                        setscheculestate('잔금일');
                                        setscheculecolor('9');
                                    }} />
                                    <Button buttonTxt={'기타'} className={`writeRadiobutton3 ${scheculestate === '기타' ? 'active' : ''}`} onPress={() => {
                                        setscheculestate('기타');
                                        setscheculecolor('8');
                                    }} />
                                </div>
                                <div
                                    style={{
                                        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                                    }}
                                >
                                    {colorlists && Object.keys(colorlists)?.map((x, i) => {
                                        console.log(x);
                                        return (
                                            <Button 
                                                buttonTxt={''} className={`writeRadiobutton3`} onPress={() => setscheculecolor(x) } 
                                                styles={{
                                                    backgroundColor: colorlists[x]?.background,
                                                    border: x === scheculecolor ? '2px solid #000' : ''
                                                }}
                                            />
                                        );
                                    })}
                                </div>
                                <div className="inputviewtype1 ">
                                    <div>제목</div>
                                    <div>
                                        <Input
                                            className={`inputs`}
                                            placeholder=""
                                            setValue={setscheculestate}
                                            value={scheculestate}
                                            name="mb_phone"
                                        />
                                    </div>
                                </div>

                                <div style={{ width: '100%', }}>
                                    <textarea
                                        onChange={(e) => {
                                            setpopcomments(e.target.value);
                                        }}
                                        placeholder='알림내용을 입력하세요.'
                                        style={{
                                            width: '100%', height: 60, padding: 12,
                                            borderRadius: 4, border: '1px solid #DDD'
                                        }}
                                        value={popcomments}
                                    ></textarea>
                                </div>
                                <div className='schduleAreaselectors'>
                                    <ScheduleInputs 
                                        buttonFlag={buttonFlag} showtype={0} setbuttonFlag={setbuttonFlag} 
                                        setsely={setsely1} setselm={setselm1} setseld={setseld1}
                                        setselsh={setselsh1} setselsmin={setselsmin1} 
                                        setseleh={setseleh1} setselemin={setselemin1} 
                                        sely={sely1} selm={selm1} seld={seld1}
                                        selsh={selsh1} selsmin={selsmin1} 
                                        seleh={seleh1} selemin={selemin1} 
                                    />
                                </div>
                                {buttonFlag === true &&
                                <div className='schduleAreaselectors'>
                                    <ScheduleInputs 
                                        buttonFlag={buttonFlag} showtype={1} setbuttonFlag={setbuttonFlag} 
                                        setsely={setsely2} setselm={setselm2} setseld={setseld2}
                                        setselsh={setselsh2} setselsmin={setselsmin2} 
                                        setseleh={setseleh2} setselemin={setselemin2}       
                                        sely={sely2} selm={selm2} seld={seld2}
                                        selsh={selsh2} selsmin={selsmin2} 
                                        seleh={seleh2} selemin={selemin2}                                   
                                    />
                                </div>
                                }
                            </div>
                            </div>
                            <div className='popbuttons' style={{ marginTop: 20 }}>
                                {eventids &&
                                <Button
                                    buttonTxt={'삭제'}
                                    className={'linenormalbutton'}
                                    styles={{ width: 100}}
                                    onPress={() => { 
                                        dispatch(
                                            open({
                                                component: '스케쥴을 삭제하시겠습니까?',
                                                title: '알림',
                                                button: "삭제",
                                                buttonCencle: "취소",       
                                                titleviewer: true,                 
                                                alert: false,
                                                onPress: () => {
                                                    dispatch(close());
                                                    let sender = {};
                                                    sender = {
                                                        eventId: eventids, // 있으면 수정
                                                    }
                                                    console.log(sender);
                                                    dispatch(loadingflas({ loading: true }));
                                                    APIS.postData('/v1/schedule/delete', sender).then(({ data }) => {
                                                        if(data){
                                                            schedulteventclear();
                                                            getschedultlist();
                                                            dispatch(
                                                                open({
                                                                    component: '스케줄이 삭제되었습니다.',
                                                                    title: '알림',
                                                                    titleviewer: true,
                                                                    alert: false,
                                                                    button: "확인",
                                                                    onPress: () => {
                                                                        dispatch(close());
                                                                    }
                                                                })
                                                            );   
                                                        }
                                                    }).catch(({ response }) => {
                                                        const { data } = response;
                                                        dispatch(
                                                            open({
                                                                component: '해당 기능을 실행할 수 없습니다. 관리자에게 문의하세요.',
                                                                title: '알림',
                                                                button: "확인",
                                                                titleviewer: true,                 
                                                                alert: false,
                                                                onPress: () => {
                                                                    dispatch(close());
                                                                },
                                                            })
                                                        );
                                                    }).finally(() => {
                                                        dispatch(loadingflas({ loading: false }));
                                                    });  

                                                },
                                                onCancelPress: () => {
                                                    dispatch(close());
                                                }
                                            })
                                        );    
                                    }}
                                />   }      
                                <Button
                                    buttonTxt={'등록'}
                                    onPress={() => { 
                                        dispatch(
                                            open({
                                                component: eventids ? '스케쥴을 수정하시겠습니까?' : '스케쥴을 등록하시겠습니까?',
                                                title: '알림',
                                                button: "등록",
                                                buttonCencle: "취소",       
                                                titleviewer: true,                 
                                                alert: false,
                                                onPress: () => {
                                                    dispatch(close());


                                                    console.log(scheculestate, scheculecolor, popcomments);
                                                    console.log(sely1, selm1, seld1, selsh1, selsmin1, seleh1, selemin1);
                                                    console.log(sely2, selm2, seld2, selsh2, selsmin2, seleh2, selemin2);

                                                    let sender = {};
                                                    let starts = '';
                                                    let ends = '';
                                                    if(buttonFlag === true){
                                                        starts = `${sely1}${selm1}${seld1}${selsh1}${selsmin1}`;
                                                        ends = `${sely2}${selm2}${seld2}${selsh2}${selsmin2}`;
                                                        sender = {
                                                            eventId: eventids, // 있으면 수정
                                                            start: moment(`${sely1}-${selm1}-${seld1} ${selsh1}:${selsmin1}`).format('YYYY-MM-DD HH:mm:00'), // 5분단위
                                                            end: moment(`${sely2}-${selm2}-${seld2} ${selsh2}:${selsmin2}`).format('YYYY-MM-DD HH:mm:00'), // 5분단위(start_at 보단 이후여야함)
                                                            summary: scheculestate, // summary 제목
                                                            description: popcomments, // 내용
                                                            colorId: scheculecolor === 'default' ? '' : scheculecolor // 컬러 키값 미입력시 기본색상으로 들어감
                                                        }
                                                    } else {
                                                        starts = `${sely1}${selm1}${seld1}${selsh1}${selsmin1}`;
                                                        ends = `${sely1}${selm1}${seld1}${seleh1}${selemin1}`;
                                                        sender = {
                                                            eventId: eventids, // 있으면 수정
                                                            start: moment(`${sely1}-${selm1}-${seld1} ${selsh1}:${selsmin1}`).format('YYYY-MM-DD HH:mm:00'), // 5분단위
                                                            end: moment(`${sely1}-${selm1}-${seld1} ${seleh1}:${selemin1}`).format('YYYY-MM-DD HH:mm:00'), // 5분단위(start_at 보단 이후여야함)
                                                            summary: scheculestate, // summary 제목
                                                            description: popcomments, // 내용
                                                            colorId: scheculecolor === 'default' ? '' : scheculecolor // 컬러 키값 미입력시 기본색상으로 들어감
                                                        }
                                                    }
                                                    let alerts = false;
                                                    let alertscomment = "";
                                                    if(starts*1 > ends*1){
                                                        alerts = true;
                                                        alertscomment = '종료일(시간)이 시작일(시간)보다 이전일수는 없습니다.';
                                                    }
                                               
                                                    if(alerts){
                                                        dispatch(
                                                            open({
                                                                component: alertscomment,
                                                                title: '알림',
                                                                titleviewer: true,
                                                                alert: false,
                                                                button: "확인",
                                                                onPress: () => {
                                                                    dispatch(close());
                                                                }
                                                            })
                                                        ); 
                                                        return;
                                                    }


                                                    console.log(sender);
                                                    // return;
                                                    dispatch(loadingflas({ loading: true }));
                                                    APIS.postData('/v1/schedule/createEvent', sender).then(({ data }) => {
                                                        if(data){
                                                            schedulteventclear();
                                                            getschedultlist();
                                                            dispatch(
                                                                open({
                                                                    component: eventids ? '스케줄이 수정되었습니다.' : '스케줄이 등록되었습니다.',
                                                                    title: '알림',
                                                                    titleviewer: true,
                                                                    alert: false,
                                                                    button: "확인",
                                                                    onPress: () => {
                                                                        dispatch(close());
                                                                    }
                                                                })
                                                            );   
                                                        }
                                                    }).catch(({ response }) => {
                                                        const { data } = response;
                                                        dispatch(
                                                            open({
                                                                component: '해당 기능을 실행할 수 없습니다. 관리자에게 문의하세요.',
                                                                title: '알림',
                                                                button: "확인",
                                                                titleviewer: true,                 
                                                                alert: false,
                                                                onPress: () => {
                                                                    dispatch(close());
                                                                },
                                                            })
                                                        );
                                                    }).finally(() => {
                                                        dispatch(loadingflas({ loading: false }));
                                                    });  

                                                },
                                                onCancelPress: () => {
                                                    dispatch(close());
                                                }
                                            })
                                        );    
                                    }}
                                />                                  
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
        }        
        </>
    )
}

